/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/sizes_conversions.js":
/*!*************************************!*\
  !*** ./src/js/sizes_conversions.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "adidas_kids_eu": () => (/* binding */ adidas_kids_eu),
/* harmony export */   "adidas_kids_us": () => (/* binding */ adidas_kids_us),
/* harmony export */   "adidas_men_eu": () => (/* binding */ adidas_men_eu),
/* harmony export */   "adidas_men_us": () => (/* binding */ adidas_men_us),
/* harmony export */   "adidas_women_eu": () => (/* binding */ adidas_women_eu),
/* harmony export */   "adidas_women_us": () => (/* binding */ adidas_women_us),
/* harmony export */   "aj_gs_eu": () => (/* binding */ aj_gs_eu),
/* harmony export */   "aj_gs_us": () => (/* binding */ aj_gs_us),
/* harmony export */   "aj_men_eu": () => (/* binding */ aj_men_eu),
/* harmony export */   "aj_men_us": () => (/* binding */ aj_men_us),
/* harmony export */   "aj_ps_eu": () => (/* binding */ aj_ps_eu),
/* harmony export */   "aj_ps_us": () => (/* binding */ aj_ps_us),
/* harmony export */   "aj_td_eu": () => (/* binding */ aj_td_eu),
/* harmony export */   "aj_td_us": () => (/* binding */ aj_td_us),
/* harmony export */   "aj_women_eu": () => (/* binding */ aj_women_eu),
/* harmony export */   "aj_women_us": () => (/* binding */ aj_women_us),
/* harmony export */   "am_men_eu": () => (/* binding */ am_men_eu),
/* harmony export */   "am_men_us": () => (/* binding */ am_men_us),
/* harmony export */   "am_women_eu": () => (/* binding */ am_women_eu),
/* harmony export */   "am_women_us": () => (/* binding */ am_women_us),
/* harmony export */   "amiri_men_eu": () => (/* binding */ amiri_men_eu),
/* harmony export */   "amiri_men_us": () => (/* binding */ amiri_men_us),
/* harmony export */   "amiri_women_eu": () => (/* binding */ amiri_women_eu),
/* harmony export */   "amiri_women_us": () => (/* binding */ amiri_women_us),
/* harmony export */   "asics_men_eu": () => (/* binding */ asics_men_eu),
/* harmony export */   "asics_men_us": () => (/* binding */ asics_men_us),
/* harmony export */   "asics_women_eu": () => (/* binding */ asics_women_eu),
/* harmony export */   "asics_women_us": () => (/* binding */ asics_women_us),
/* harmony export */   "balenciaga_men_eu": () => (/* binding */ balenciaga_men_eu),
/* harmony export */   "balenciaga_men_us": () => (/* binding */ balenciaga_men_us),
/* harmony export */   "balenciaga_women_eu": () => (/* binding */ balenciaga_women_eu),
/* harmony export */   "balenciaga_women_us": () => (/* binding */ balenciaga_women_us),
/* harmony export */   "birkenstock_men_eu": () => (/* binding */ birkenstock_men_eu),
/* harmony export */   "birkenstock_men_us": () => (/* binding */ birkenstock_men_us),
/* harmony export */   "birkenstock_women_eu": () => (/* binding */ birkenstock_women_eu),
/* harmony export */   "birkenstock_women_us": () => (/* binding */ birkenstock_women_us),
/* harmony export */   "botegga_men_eu": () => (/* binding */ botegga_men_eu),
/* harmony export */   "botegga_men_us": () => (/* binding */ botegga_men_us),
/* harmony export */   "botegga_women_eu": () => (/* binding */ botegga_women_eu),
/* harmony export */   "botegga_women_us": () => (/* binding */ botegga_women_us),
/* harmony export */   "burberry_men_eu": () => (/* binding */ burberry_men_eu),
/* harmony export */   "burberry_men_us": () => (/* binding */ burberry_men_us),
/* harmony export */   "burberry_women_eu": () => (/* binding */ burberry_women_eu),
/* harmony export */   "burberry_women_us": () => (/* binding */ burberry_women_us),
/* harmony export */   "celine_men_eu": () => (/* binding */ celine_men_eu),
/* harmony export */   "celine_men_us": () => (/* binding */ celine_men_us),
/* harmony export */   "celine_women_eu": () => (/* binding */ celine_women_eu),
/* harmony export */   "celine_women_us": () => (/* binding */ celine_women_us),
/* harmony export */   "cl_men_eu": () => (/* binding */ cl_men_eu),
/* harmony export */   "cl_men_us": () => (/* binding */ cl_men_us),
/* harmony export */   "cl_women_eu": () => (/* binding */ cl_women_eu),
/* harmony export */   "cl_women_us": () => (/* binding */ cl_women_us),
/* harmony export */   "converse_men_eu": () => (/* binding */ converse_men_eu),
/* harmony export */   "converse_men_us": () => (/* binding */ converse_men_us),
/* harmony export */   "converse_women_eu": () => (/* binding */ converse_women_eu),
/* harmony export */   "converse_women_us": () => (/* binding */ converse_women_us),
/* harmony export */   "crocs_men_eu": () => (/* binding */ crocs_men_eu),
/* harmony export */   "crocs_men_us": () => (/* binding */ crocs_men_us),
/* harmony export */   "crocs_women_eu": () => (/* binding */ crocs_women_eu),
/* harmony export */   "crocs_women_us": () => (/* binding */ crocs_women_us),
/* harmony export */   "dg_men_eu": () => (/* binding */ dg_men_eu),
/* harmony export */   "dg_men_us": () => (/* binding */ dg_men_us),
/* harmony export */   "dg_women_eu": () => (/* binding */ dg_women_eu),
/* harmony export */   "dg_women_us": () => (/* binding */ dg_women_us),
/* harmony export */   "dior_men_eu": () => (/* binding */ dior_men_eu),
/* harmony export */   "dior_men_us": () => (/* binding */ dior_men_us),
/* harmony export */   "dior_women_eu": () => (/* binding */ dior_women_eu),
/* harmony export */   "dior_women_us": () => (/* binding */ dior_women_us),
/* harmony export */   "disquared2_men_eu": () => (/* binding */ disquared2_men_eu),
/* harmony export */   "disquared2_men_us": () => (/* binding */ disquared2_men_us),
/* harmony export */   "disquared2_women_eu": () => (/* binding */ disquared2_women_eu),
/* harmony export */   "disquared2_women_us": () => (/* binding */ disquared2_women_us),
/* harmony export */   "disquared_men_eu": () => (/* binding */ disquared_men_eu),
/* harmony export */   "disquared_men_us": () => (/* binding */ disquared_men_us),
/* harmony export */   "fendi_men_eu": () => (/* binding */ fendi_men_eu),
/* harmony export */   "fendi_men_us": () => (/* binding */ fendi_men_us),
/* harmony export */   "fendi_women_eu": () => (/* binding */ fendi_women_eu),
/* harmony export */   "fendi_women_us": () => (/* binding */ fendi_women_us),
/* harmony export */   "givenchy_men_eu": () => (/* binding */ givenchy_men_eu),
/* harmony export */   "givenchy_men_us": () => (/* binding */ givenchy_men_us),
/* harmony export */   "givenchy_women_eu": () => (/* binding */ givenchy_women_eu),
/* harmony export */   "givenchy_women_us": () => (/* binding */ givenchy_women_us),
/* harmony export */   "gucci_men_eu": () => (/* binding */ gucci_men_eu),
/* harmony export */   "gucci_men_us": () => (/* binding */ gucci_men_us),
/* harmony export */   "gucci_women_eu": () => (/* binding */ gucci_women_eu),
/* harmony export */   "gucci_women_us": () => (/* binding */ gucci_women_us),
/* harmony export */   "gz_men_eu": () => (/* binding */ gz_men_eu),
/* harmony export */   "gz_men_us": () => (/* binding */ gz_men_us),
/* harmony export */   "gz_women_eu": () => (/* binding */ gz_women_eu),
/* harmony export */   "gz_women_us": () => (/* binding */ gz_women_us),
/* harmony export */   "hermes_men_eu": () => (/* binding */ hermes_men_eu),
/* harmony export */   "hermes_men_us": () => (/* binding */ hermes_men_us),
/* harmony export */   "hermes_paris_men_eu": () => (/* binding */ hermes_paris_men_eu),
/* harmony export */   "hermes_paris_men_us": () => (/* binding */ hermes_paris_men_us),
/* harmony export */   "hermes_paris_women_eu": () => (/* binding */ hermes_paris_women_eu),
/* harmony export */   "hermes_paris_women_us": () => (/* binding */ hermes_paris_women_us),
/* harmony export */   "hermes_women_eu": () => (/* binding */ hermes_women_eu),
/* harmony export */   "hermes_women_us": () => (/* binding */ hermes_women_us),
/* harmony export */   "loro_men_eu": () => (/* binding */ loro_men_eu),
/* harmony export */   "loro_men_us": () => (/* binding */ loro_men_us),
/* harmony export */   "loro_women_eu": () => (/* binding */ loro_women_eu),
/* harmony export */   "loro_women_us": () => (/* binding */ loro_women_us),
/* harmony export */   "loubouton_men_eu": () => (/* binding */ loubouton_men_eu),
/* harmony export */   "loubouton_men_us": () => (/* binding */ loubouton_men_us),
/* harmony export */   "loubouton_women_eu": () => (/* binding */ loubouton_women_eu),
/* harmony export */   "loubouton_women_us": () => (/* binding */ loubouton_women_us),
/* harmony export */   "lv_men_eu": () => (/* binding */ lv_men_eu),
/* harmony export */   "lv_men_us": () => (/* binding */ lv_men_us),
/* harmony export */   "lv_nike_men_eu": () => (/* binding */ lv_nike_men_eu),
/* harmony export */   "lv_nike_men_us": () => (/* binding */ lv_nike_men_us),
/* harmony export */   "lv_supreme_men_eu": () => (/* binding */ lv_supreme_men_eu),
/* harmony export */   "lv_supreme_men_us": () => (/* binding */ lv_supreme_men_us),
/* harmony export */   "lv_women_eu": () => (/* binding */ lv_women_eu),
/* harmony export */   "lv_women_us": () => (/* binding */ lv_women_us),
/* harmony export */   "manolo_men_eu": () => (/* binding */ manolo_men_eu),
/* harmony export */   "manolo_men_us": () => (/* binding */ manolo_men_us),
/* harmony export */   "manolo_women_eu": () => (/* binding */ manolo_women_eu),
/* harmony export */   "manolo_women_us": () => (/* binding */ manolo_women_us),
/* harmony export */   "moncler_men_eu": () => (/* binding */ moncler_men_eu),
/* harmony export */   "moncler_men_us": () => (/* binding */ moncler_men_us),
/* harmony export */   "moncler_women_eu": () => (/* binding */ moncler_women_eu),
/* harmony export */   "moncler_women_us": () => (/* binding */ moncler_women_us),
/* harmony export */   "new_balance_men_eu": () => (/* binding */ new_balance_men_eu),
/* harmony export */   "new_balance_men_us": () => (/* binding */ new_balance_men_us),
/* harmony export */   "new_balance_women_eu": () => (/* binding */ new_balance_women_eu),
/* harmony export */   "new_balance_women_us": () => (/* binding */ new_balance_women_us),
/* harmony export */   "nike_men_eu": () => (/* binding */ nike_men_eu),
/* harmony export */   "nike_men_us": () => (/* binding */ nike_men_us),
/* harmony export */   "nike_women_eu": () => (/* binding */ nike_women_eu),
/* harmony export */   "nike_women_us": () => (/* binding */ nike_women_us),
/* harmony export */   "offwhite_men_eu": () => (/* binding */ offwhite_men_eu),
/* harmony export */   "offwhite_men_us": () => (/* binding */ offwhite_men_us),
/* harmony export */   "offwhite_women_eu": () => (/* binding */ offwhite_women_eu),
/* harmony export */   "offwhite_women_us": () => (/* binding */ offwhite_women_us),
/* harmony export */   "or_men_eu": () => (/* binding */ or_men_eu),
/* harmony export */   "or_men_us": () => (/* binding */ or_men_us),
/* harmony export */   "or_women_eu": () => (/* binding */ or_women_eu),
/* harmony export */   "or_women_us": () => (/* binding */ or_women_us),
/* harmony export */   "pa_men_eu": () => (/* binding */ pa_men_eu),
/* harmony export */   "pa_men_us": () => (/* binding */ pa_men_us),
/* harmony export */   "pa_women_eu": () => (/* binding */ pa_women_eu),
/* harmony export */   "pa_women_us": () => (/* binding */ pa_women_us),
/* harmony export */   "prada_men_eu": () => (/* binding */ prada_men_eu),
/* harmony export */   "prada_men_us": () => (/* binding */ prada_men_us),
/* harmony export */   "prada_women_eu": () => (/* binding */ prada_women_eu),
/* harmony export */   "prada_women_us": () => (/* binding */ prada_women_us),
/* harmony export */   "ugg_men_eu": () => (/* binding */ ugg_men_eu),
/* harmony export */   "ugg_men_us": () => (/* binding */ ugg_men_us),
/* harmony export */   "ugg_women_eu": () => (/* binding */ ugg_women_eu),
/* harmony export */   "ugg_women_us": () => (/* binding */ ugg_women_us),
/* harmony export */   "valentino_men_eu": () => (/* binding */ valentino_men_eu),
/* harmony export */   "valentino_men_us": () => (/* binding */ valentino_men_us),
/* harmony export */   "valentino_women_eu": () => (/* binding */ valentino_women_eu),
/* harmony export */   "valentino_women_us": () => (/* binding */ valentino_women_us),
/* harmony export */   "vans_men_eu": () => (/* binding */ vans_men_eu),
/* harmony export */   "vans_men_us": () => (/* binding */ vans_men_us),
/* harmony export */   "vans_women_eu": () => (/* binding */ vans_women_eu),
/* harmony export */   "vans_women_us": () => (/* binding */ vans_women_us),
/* harmony export */   "versace_men_eu": () => (/* binding */ versace_men_eu),
/* harmony export */   "versace_men_us": () => (/* binding */ versace_men_us),
/* harmony export */   "versace_women_eu": () => (/* binding */ versace_women_eu),
/* harmony export */   "versace_women_us": () => (/* binding */ versace_women_us),
/* harmony export */   "yeezy_men_eu": () => (/* binding */ yeezy_men_eu),
/* harmony export */   "yeezy_men_us": () => (/* binding */ yeezy_men_us),
/* harmony export */   "yeezy_rnnr_eu": () => (/* binding */ yeezy_rnnr_eu),
/* harmony export */   "yeezy_rnnr_us": () => (/* binding */ yeezy_rnnr_us),
/* harmony export */   "yeezy_slide_eu": () => (/* binding */ yeezy_slide_eu),
/* harmony export */   "yeezy_slide_us": () => (/* binding */ yeezy_slide_us)
/* harmony export */ });
//===================
// Air Jordan + Nike
//===================
// Men
var nike_men_eu = {
  3: 35.5,
  3.5: 36,
  4: 36.5,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 40,
  '6|39': 39,
  '6|40': 40,
  6.5: 40.5,
  7: 41,
  7.5: 42,
  8: 42.5,
  8.5: 43,
  9: 44,
  9.5: 44.5,
  10: 45,
  10.5: 45.5,
  11: 46,
  11.5: 47,
  12: 47.5,
  12.5: 48,
  13: 48.5,
  13.5: 49,
  14: 49.5,
  14.5: 50,
  15: 50.5,
  15.5: 51,
  16: 51.5,
  16.5: 52,
  17: 52.5
};
var nike_men_us = {
  3: 3.5,
  3.5: 4,
  4: 4.5,
  4.5: 5,
  5: 5.5,
  5.5: 6,
  6: 7,
  '6|39': 6.5,
  '6|40': 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15,
  14.5: 15.5,
  15: 16,
  15.5: 16.5,
  16: 17,
  16.5: 17.5,
  17: 18
};
// women
var nike_women_eu = {
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37.5,
  4.5: 38,
  5: 38.5,
  5.5: 39,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 42,
  8: 42.5,
  8.5: 43,
  9: 44,
  9.5: 44.5,
  10: 45,
  10.5: 45.5,
  11: 46,
  11.5: 47,
  12: 47.5,
  12.5: 48,
  13: 48.5,
  13.5: 49,
  14: 49.5,
  14.5: 50,
  15: 50.5,
  15.5: 51
};
var nike_women_us = {
  1.5: 4,
  2: 4.5,
  2.5: 5,
  3: 5.5,
  3.5: 6,
  4: 6.5,
  4.5: 7,
  5: 7.5,
  5.5: 8,
  6: 8.5,
  6.5: 9,
  7: 9.5,
  7.5: 10,
  8: 10.5,
  8.5: 11,
  9: 11.5,
  9.5: 12,
  10: 12.5,
  10.5: 13,
  11: 13.5,
  11.5: 14,
  12: 14.5,
  12.5: 15,
  13: 15.5,
  13.5: 16,
  14: 16.5,
  14.5: 17,
  15: 17.5,
  15.5: 18,
  16: 18.5
};

// men
var aj_men_eu = {
  3: 35.5,
  3.5: 36,
  4: 36.5,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 40,
  '6|39': 39,
  '6|40': 40,
  6.5: 40.5,
  7: 41,
  7.5: 42,
  8: 42.5,
  8.5: 43,
  9: 44,
  9.5: 44.5,
  10: 45,
  10.5: 45.5,
  11: 46,
  11.5: 47,
  12: 47.5,
  12.5: 48,
  13: 48.5,
  13.5: 49,
  14: 49.5,
  14.5: 50,
  15: 50.5,
  15.5: 51,
  16: 51.5,
  16.5: 52,
  17: 52.5
};
var aj_men_us = {
  3: 3.5,
  3.5: 4,
  4: 4.5,
  4.5: 5,
  5: 5.5,
  5.5: 6,
  6: 7,
  '6|39': 6.5,
  '6|40': 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15,
  14.5: 15.5,
  15: 16,
  15.5: 16.5,
  16: 17,
  16.5: 17.5,
  17: 18
};
// women
var aj_women_eu = {
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37.5,
  4.5: 38,
  5: 38.5,
  5.5: 39,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 42,
  8: 42.5,
  8.5: 43,
  9: 44,
  9.5: 44.5,
  10: 45,
  10.5: 45.5,
  11: 46,
  11.5: 47,
  12: 47.5,
  12.5: 48,
  13: 48.5,
  13.5: 49,
  14: 49.5,
  14.5: 50,
  15: 50.5,
  15.5: 51
};
var aj_women_us = {
  1.5: 4,
  2: 4.5,
  2.5: 5,
  3: 5.5,
  3.5: 6,
  4: 6.5,
  4.5: 7,
  5: 7.5,
  5.5: 8,
  6: 8.5,
  6.5: 9,
  7: 9.5,
  7.5: 10,
  8: 10.5,
  8.5: 11,
  9: 11.5,
  9.5: 12,
  10: 12.5,
  10.5: 13,
  11: 13.5,
  11.5: 14,
  12: 14.5,
  12.5: 15,
  13: 15.5,
  13.5: 16,
  14: 16.5,
  14.5: 17,
  15: 17.5,
  15.5: 18,
  16: 18.5
};
// kids
var aj_gs_eu = {
  13.5: 32,
  1: 33,
  1.5: 33.5,
  2: 34,
  2.5: 35,
  3: 35.5,
  3.5: 36,
  4: 36.5,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: "39, 40",
  "6|39": 39,
  "6|40": 40
};
var aj_gs_us = {
  13.5: "1Y",
  1: "1.5Y",
  1.5: "2Y",
  2: "2.5Y",
  2.5: "3Y",
  3: "3.5Y",
  3.5: "4Y",
  4: "4.5Y",
  4.5: "5Y",
  5: "5.5Y",
  5.5: "6Y",
  6: "6.5Y",
  "6|39": "6.5Y",
  "6|40": "7Y",
  6.5: "7Y"
};
// GS
var aj_ps_eu = {
  7.5: 25,
  8: 25.5,
  8.5: 26,
  9: 26.5,
  9.5: 27,
  10: 27.5,
  10.5: 28,
  11: 28.5,
  11.5: 29.5,
  12: 30,
  12.5: 31,
  13: 31.5,
  13.5: 32,
  1: 33,
  1.5: 33.5,
  2: 34,
  2.5: 35
};
var aj_ps_us = {
  7.5: "8C",
  8: "8.5C",
  8.5: "9C",
  9: "9.5C",
  9.5: "10C",
  10: "10.5C",
  10.5: "11C",
  11: "11.5C",
  11.5: "12C",
  12: "12.5C",
  12.5: "13C",
  13: "13.5C",
  13.5: "1Y",
  1: "1.5Y",
  1.5: "2Y",
  2: "2.5Y",
  2.5: "3Y"
};
// TD
var aj_td_eu = {
  0.5: 16,
  1: 16.5,
  1.5: 17,
  2: 18,
  2.5: 18.5,
  3: 19,
  3.5: 19.5,
  4: 20,
  4.5: 21,
  5: 21.5,
  5.5: 22,
  6: 22.5,
  6.5: 23.5,
  7: 24,
  7.5: 25,
  8: 25.5,
  8.5: 26,
  9: 26.5,
  9.5: 27
};
var aj_td_us = {
  0.5: 1,
  1: 1.5,
  1.5: 2,
  2: 2.5,
  2.5: 3,
  3: 3.5,
  3.5: 4,
  4: 4.5,
  4.5: 5,
  5: 5.5,
  5.5: 6,
  6: 6.5,
  6.5: 7,
  7: 7.5,
  7.5: 8,
  8: 8.5,
  8.5: 9,
  9: 9.5,
  9.5: 10
};

//===================
// Adidas
//===================
// Men
var adidas_men_eu = {
  3.5: 36,
  4: "36 2/3",
  4.5: "37 1/3",
  5: 38,
  5.5: "38 2/3",
  6: "39 1/3",
  6.5: 40,
  7: "40 2/3",
  7.5: "41 1/3",
  8: 42,
  8.5: "42 2/3",
  9: "43 1/3",
  9.5: 44,
  10: "44 2/3",
  10.5: "45 1/3",
  11: 46,
  11.5: "46 2/3",
  12: "47 1/3",
  12.5: 48,
  13: "48 2/3",
  13.5: "49 1/3",
  14: 50,
  14.5: "50 2/3",
  15: "51 1/3",
  16: "52 2/3",
  17: "53 1/3",
  18: "54 2/3",
  19: "55 2/3"
};
var adidas_men_us = {
  3.5: 4,
  4: 4.5,
  4.5: 5,
  5: 5.5,
  5.5: 6,
  6: 6.5,
  6.5: 7,
  7: 7.5,
  7.5: 8,
  8: 8.5,
  8.5: 9,
  9: 9.5,
  9.5: 10,
  10: 10.5,
  10.5: 11,
  11: 11.5,
  11.5: 12,
  12: 12.5,
  12.5: 13,
  13: 13.5,
  13.5: 14,
  14: 14.5,
  14.5: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19,
  19: 20
};
// Women
var adidas_women_eu = {
  3.5: 36,
  4: "36 2/3",
  4.5: "37 1/3",
  5: 38,
  5.5: "38 2/3",
  6: "39 1/3",
  6.5: 40,
  7: "40 2/3",
  7.5: "41 1/3",
  8: 42,
  8.5: "42 2/3",
  9: "43 1/3",
  9.5: 44,
  10: "44 2/3",
  10.5: "45 1/3",
  11: 46,
  11.5: "46 2/3",
  12: "47 1/3",
  12.5: 48,
  13: "48 2/3",
  13.5: "49 1/3",
  14: 50
};
var adidas_women_us = {
  3.5: 5,
  4: 5.5,
  4.5: 6,
  5: 6.5,
  5.5: 7,
  6: 7.5,
  6.5: 8,
  7: 8.5,
  7.5: 9,
  8: 9.5,
  8.5: 10,
  9: 10.5,
  9.5: 11,
  10: 11.5,
  10.5: 12,
  11: 12.5,
  11.5: 13,
  12: 13.5,
  12.5: 14,
  13: 14.5,
  13.5: 15,
  14: 15.5
};
// kids
var adidas_kids_eu = {
  10: 27.5,
  10.5: 28,
  11: 28.5,
  11.5: 29.5,
  12: 30,
  12.5: 31,
  13: 31.5,
  13.5: 32,
  1: 33,
  1.5: 33.5,
  2: 34,
  2.5: 35
};
var adidas_kids_us = {
  10: 10.5,
  10.5: 11,
  11: 11.5,
  11.5: 12,
  12: 12.5,
  12.5: 13,
  13: 13.5,
  13.5: 1,
  1: 1.5,
  1.5: 2,
  2: 2.5,
  2.5: 3
};

//===================
// Yeezy
//===================
var yeezy_men_eu = {
  3.5: 36,
  4: "36 2/3",
  4.5: "37 1/3",
  5: 38,
  5.5: "38 2/3",
  6: "39 1/3",
  6.5: 40,
  7: "40 2/3",
  7.5: "41 1/3",
  8: 42,
  8.5: "42 2/3",
  9: "43 1/3",
  9.5: 44,
  10: "44 2/3",
  10.5: "45 1/3",
  11: 46,
  11.5: "46 2/3",
  12: "47 1/3",
  12.5: 48,
  13: "48 2/3",
  13.5: "49 1/3",
  14: 50,
  14.5: "50 2/3",
  15: "51 1/3",
  16: "52 2/3",
  17: "53 1/3",
  18: "54 2/3",
  19: "55 2/3"
};
var yeezy_men_us = {
  3.5: 4,
  4: 4.5,
  4.5: 5,
  5: 5.5,
  5.5: 6,
  6: 6.5,
  6.5: 7,
  7: 7.5,
  7.5: 8,
  8: 8.5,
  8.5: 9,
  9: 9.5,
  9.5: 10,
  10: 10.5,
  10.5: 11,
  11: 11.5,
  11.5: 12,
  12: 12.5,
  12.5: 13,
  13: 13.5,
  13.5: 14,
  14: 14.5,
  14.5: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19,
  19: 20
};
// Yeezy slides
var yeezy_slide_eu = {
  4: 37,
  5: 38,
  6: 39,
  7: 40.5,
  8: 42,
  9: 43,
  10: 44.5,
  11: 46,
  12: 47,
  13: 48.5,
  14: 50,
  15: 51,
  16: 52
};
var yeezy_slide_us = {
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 11,
  12: 12,
  13: 13,
  14: 14,
  15: 15,
  16: 16
};
// Yeezy rnnr
var yeezy_rnnr_eu = {
  4: 37,
  5: 38,
  6: 39,
  7: 40.5,
  8: 42,
  9: 43,
  10: 44.5,
  11: 46,
  12: 47,
  13: 48.5,
  14: 50,
  15: 51,
  16: 52
};
var yeezy_rnnr_us = {
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 11,
  12: 12,
  13: 13,
  14: 14,
  15: 15,
  16: 16
};
//===================
// New Balance
//===================
// Men
var new_balance_men_eu = {
  3.5: 36,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13.5: 49,
  14.5: 50,
  15.5: 51,
  16.5: 52,
  17.5: 53,
  18.5: 54,
  19.5: 55
};
var new_balance_men_us = {
  3.5: 4,
  4: 4.5,
  4.5: 5,
  5: 5.5,
  5.5: 6,
  6: 6.5,
  6.5: 7,
  7: 7.5,
  7.5: 8,
  8: 8.5,
  8.5: 9,
  9: 9.5,
  9.5: 10,
  10: 10.5,
  10.5: 11,
  11: 11.5,
  11.5: 12,
  12: 12.5,
  12.5: 13,
  13.5: 14,
  14.5: 15,
  15.5: 16,
  16.5: 17,
  17.5: 18,
  18.5: 19,
  19.5: 20
};
// Women
var new_balance_women_eu = {
  3.5: 36,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5
};
var new_balance_women_us = {
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11,
  9.5: 11.5,
  10: 12,
  10.5: 12.5,
  11: 13,
  11.5: 13.5,
  12: 14,
  12.5: 15
};

//===================
// Louis Vuitton
//===================
// Men
var lv_men_eu = {
  1.5: 34,
  2: [34.5, 35],
  2.5: 35.5,
  3: [36, 36.5],
  3.5: [37, 37.5],
  4: [38, 38.5],
  4.5: 39,
  5: 39.5,
  5.5: 40,
  6: 40.5,
  6.5: 41,
  7: 41.5,
  7.5: 42,
  8: 42.5,
  8.5: 43,
  9: 43.5,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46,
  12: 46.5,
  12.5: 47,
  13: 47.5,
  13.5: 48,
  14: 48.5,
  14.5: 49,
  15: 49.5,
  15.5: 50,
  16: 50.5
};
var lv_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// Men
var lv_nike_men_eu = {
  3: 35.5,
  3.5: 36,
  4: 36.5,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 40.5,
  7: 41,
  7.5: 42,
  8: 42.5,
  8.5: 43,
  9: 44,
  9.5: 44.5,
  10: 45,
  10.5: 45.5,
  11: 46,
  11.5: 47,
  12: 47.5,
  12.5: 48,
  13: 48.5,
  13.5: 49,
  14: 49.5,
  14.5: 50,
  15: 50.5,
  15.5: 51,
  16: 51.5,
  16.5: 52,
  17: 52.5
};
var lv_nike_men_us = {
  3: 3.5,
  3.5: 4,
  4: 4.5,
  4.5: 5,
  5: 5.5,
  5.5: 6,
  6: 6.5,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15,
  14.5: 15.5,
  15: 16,
  15.5: 16.5,
  16: 17,
  16.5: 17.5,
  17: 18
};
var lv_supreme_men_eu = {
  1.5: 34,
  2: "34.5-35",
  2.5: 35.5,
  3: "36-36.5",
  3.5: "37-37.5",
  4: "38-38.5",
  4.5: 39,
  5: 39.5,
  5.5: 40,
  6: 40.5,
  6.5: 41,
  7: 41.5,
  7.5: 42,
  8: 42.5,
  8.5: 43,
  9: 43.5,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46,
  12: 46.5,
  12.5: 47,
  13: 47.5,
  13.5: 48,
  14: 48.5,
  14.5: 49,
  15: 49.5,
  15.5: 50,
  16: 50.5
};
var lv_supreme_men_us = {
  1.5: 2.5,
  2: 3,
  2.5: 3.5,
  3: 4,
  3.5: 4.5,
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15,
  14.5: 15.5,
  15: 16,
  15.5: 16.5,
  16: 17
};
// Women
var lv_women_eu = {
  1: 34.5,
  1.5: 35,
  2: 35.5,
  2.5: 36,
  3: 36.5,
  3.5: 37,
  4: 37.5,
  4.5: 38,
  5: 38.5,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41,
  8: 41.5,
  8.5: 42,
  9: 42.5
};
var lv_women_us = {
  1: 4,
  1.5: 4.5,
  2: 5,
  2.5: 5.5,
  3: 6,
  3.5: 7,
  4: 7.5,
  4.5: 8,
  5: 8.5,
  5.5: 9,
  6: 9.5,
  6.5: 10,
  7: 20.5,
  7.5: 10,
  8: 11
};

//===================
// Dior
//===================
// Men
var dior_men_eu = {
  4: 38,
  4.5: 38.5,
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  12.5: 46.5,
  13: 47,
  13.5: 47.5,
  14: 48
};
var dior_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// Women
var dior_women_eu = {
  1.5: 34,
  2: 34.5,
  2.5: 35,
  3: 35.5,
  3.5: 36,
  4: 36.5,
  4.5: 37,
  5: 37.5,
  5.5: 38,
  6: 38.5,
  6.5: 39,
  7: 39.5,
  7.5: 40,
  8: 40.5,
  8.5: 41,
  9: 41.5,
  9.5: 42,
  10: 42.5
};
var dior_women_us = {
  2: 4.5,
  2.5: 5,
  3: 5.5,
  3.5: 6,
  4: 6.5,
  4.5: 7,
  5: 7.5,
  5.5: 8,
  6: 8.5,
  6.5: 9,
  7: 9.5,
  7.5: 10,
  8: 10.5,
  8.5: 11,
  9: 11.5,
  9.5: 12,
  10: 12.5
};

//===================
// Loro Piana
//===================
// Men - same as dior
var loro_men_eu = {
  4: 38,
  4.5: 38.5,
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  12.5: 46.5,
  13: 47,
  13.5: 47.5,
  14: 48
};
var loro_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// Women - custom (7 is highest loro sell)
var loro_women_eu = {
  1.5: 34,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42,
  9.5: 42.5,
  10: 43
};
var loro_women_us = {
  2: 5,
  2.5: 5.5,
  3: 6,
  3.5: 6.5,
  4: 7,
  4.5: 7.5,
  5: 8,
  5.5: 8.5,
  6: 9,
  6.5: 9.5,
  7: 10,
  7.5: 10.5,
  8: 11,
  8.5: 11.5,
  9: 12,
  9.5: 12.5,
  10: 13
};

//===================
// Balenciaga
//===================
// Men
var balenciaga_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var balenciaga_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var balenciaga_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var balenciaga_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};

//===================
// Birkenstock
//===================
// Men
var birkenstock_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var birkenstock_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var birkenstock_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var birkenstock_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
//Amiri
//===================
// Men
var amiri_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var amiri_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// Women
var amiri_women_eu = {
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var amiri_women_us = {
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Alexander Mcqueen
//===================
var am_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var am_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var am_women_eu = {
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var am_women_us = {
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};

//===================
// Burberry
//===================
var burberry_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var burberry_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// Women
var burberry_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var burberry_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};

//===================
// Botegga
//===================
var botegga_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var botegga_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};

// women
var botegga_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var botegga_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
//===================
// loubouton
//===================
var loubouton_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var loubouton_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// Women
var loubouton_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var loubouton_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Converse
//===================
var converse_men_eu = {
  3: 35,
  3.5: 36,
  4: 36.5,
  4.5: 37,
  5: 37.5,
  5.5: 38,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 41,
  8: 41.5,
  8.5: 42,
  9: 42.5,
  9.5: 43,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 46,
  12: 46.5,
  12.5: 47,
  13: 48,
  14: 49,
  15: 50,
  16: 51.5,
  17: 53,
  18: 54
};
var converse_men_us = {
  3: 3,
  3.5: 3.5,
  4: 4,
  4.5: 4.5,
  5: 5,
  5.5: 5.5,
  6: 6,
  6.5: 6.5,
  7: 7,
  7.5: 7.5,
  8: 8,
  8.5: 8.5,
  9: 9,
  9.5: 9.5,
  10: 10,
  10.5: 10.5,
  11: 11,
  11.5: 11.5,
  12: 12,
  12.5: 12.5,
  13: 13,
  14: 14,
  15: 15,
  16: 16,
  17: 17,
  18: 18
};
// women
var converse_women_eu = {
  4: 35,
  4.5: 35.5,
  5: 36,
  5.5: 36.5,
  6: 37,
  6.5: 37.5,
  7: 38,
  7.5: 38.5,
  8: 39,
  8.5: 39.5,
  9: 40,
  9.5: 40.5,
  10: 41,
  11: 42
};
var converse_women_us = {
  4: 2,
  4.5: 2.5,
  5: 3,
  5.5: 3.5,
  6: 4,
  6.5: 4.5,
  7: 5,
  7.5: 5.5,
  8: 6,
  8.5: 6.5,
  9: 7,
  9.5: 7.5,
  10: 8,
  11: 9
};
//===================
// Disquared
//===================
var disquared_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var disquared_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};

//===================
// Disquared2
//===================
var disquared2_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var disquared2_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// Women
var disquared2_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var disquared2_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Crocs
//===================
var crocs_men_eu = {
  3: "36-37",
  4: "37-38",
  5: "38-39",
  6: "39-40",
  7: "41-42",
  8: "42-43",
  9: "43-44",
  10: "45-46",
  11: "46-47",
  12: "48-49",
  13: "49-50",
  14: "50-51",
  15: "51-52"
};
var crocs_men_us = {
  3: 4,
  4: 5,
  5: 6,
  6: 7,
  7: 8,
  8: 9,
  9: 10,
  10: 11,
  11: 12,
  12: 13,
  13: 14,
  14: 15,
  15: 16
};
// women
var crocs_women_eu = {
  3: "36-37",
  4: "37-38",
  5: "38-39",
  6: "39-40",
  7: "41-42",
  8: "42-43",
  9: "43-44",
  10: "45-46",
  11: "46-47",
  12: "48-49",
  13: "49-50",
  14: "50-51",
  15: "51-52"
};
var crocs_women_us = {
  3: 4,
  4: 5,
  5: 6,
  6: 7,
  7: 8,
  8: 9,
  9: 10,
  10: 11,
  11: 12,
  12: 13,
  13: 14,
  14: 15,
  15: 16
};
//===================
// Fendi
//===================
var fendi_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var fendi_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// women
var fendi_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var fendi_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
//===================
// Celine
//===================
var celine_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var celine_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// women
var celine_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var celine_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
//===================
// D&G
//===================
var dg_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var dg_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// women
var dg_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var dg_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
//===================
// Vans
//===================
var vans_men_eu = {
  2.5: 34.5,
  3: 35,
  3.5: 36,
  4: 36.5,
  4.5: 37,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 40,
  7: 40.5,
  7.5: 41,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 46,
  12: 47,
  13: 48,
  14: 49,
  15: 50
};
var vans_men_us = {
  2.5: 3.5,
  3: 4,
  3.5: 4.5,
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  12: 13,
  13: 14,
  14: 15,
  15: 16
};
// women
var vans_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var vans_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
//===================
// Giuseppe Zanotti
//===================
var gz_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var gz_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// women
var gz_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var gz_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};

//===================
// Hermes
//===================
var hermes_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var hermes_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var hermes_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var hermes_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Hermes paris
//===================
var hermes_paris_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var hermes_paris_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var hermes_paris_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var hermes_paris_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Gucci
//===================
var gucci_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var gucci_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var gucci_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var gucci_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Givenchy
//===================
var givenchy_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var givenchy_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// women
var givenchy_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var givenchy_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
//===================
// manolo
//===================
var manolo_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var manolo_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var manolo_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var manolo_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Moncler
//===================
var moncler_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var moncler_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// women
var moncler_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var moncler_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
//===================
// off-white
//===================
var offwhite_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var offwhite_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};

// women
var offwhite_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var offwhite_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};

//===================
// Palm Angels
//===================
var pa_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var pa_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var pa_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var pa_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// Prada
//===================
var prada_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var prada_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var prada_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var prada_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};
//===================
// UGG
//===================
var ugg_men_eu = {
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42,
  10: 43
};
var ugg_men_us = {
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11,
  10: 12
};
// women
var ugg_women_eu = {
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  "6|39": 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42,
  10: 43
};
var ugg_women_us = {
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  "6|39": 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11,
  10: 12
};

//===================
// Valentino
//===================
var valentino_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var valentino_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};

// women
var valentino_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var valentino_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};

//===================
// Versace
//===================
var versace_men_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var versace_men_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};
// women
var versace_women_eu = {
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 45.5,
  11.5: 46.5,
  12: 47,
  12.5: 47.5,
  13: 48.5,
  13.5: 49,
  14: 49.5
};
var versace_women_us = {
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  12.5: 13.5,
  13: 14,
  13.5: 14.5,
  14: 15
};

//===================
// Christian Louboutin
//===================
var cl_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var cl_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};
// women
var cl_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var cl_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};

//===================
// on-running
//===================
var or_men_eu = {
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43,
  9.5: 43.5,
  10: 44,
  10.5: 44.5,
  11: 45,
  11.5: 45.5,
  12: 46,
  13: 47,
  13.5: 47.5,
  14: 48,
  15: 49,
  16: 50,
  17: 51,
  18: 52
};
var or_men_us = {
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  13.5: 14.5,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19
};

// women
var or_women_eu = {
  1: 34,
  1.5: 34.5,
  2: 35,
  2.5: 35.5,
  3: 36,
  3.5: 36.5,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 38.5,
  6: 39,
  6.5: 39.5,
  7: 40,
  7.5: 40.5,
  8: 41,
  8.5: 41.5,
  9: 42
};
var or_women_us = {
  1: 3,
  1.5: 3.5,
  2: 4,
  2.5: 4.5,
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11
};

//=========
// asics
//=========

var asics_men_eu = {
  3: 36,
  3.5: 37,
  4: 37.5,
  4.5: 38,
  5: 39,
  5.5: 39.5,
  6: 40,
  6.5: 40.5,
  7: 41.5,
  7.5: 42,
  8: 42.5,
  8.5: 43.5,
  9: 44,
  9.5: 44.5,
  10: 45,
  10.5: 46,
  11: 46.5,
  11.5: 47,
  12: 48,
  13: 49,
  14: 50.5,
  15: 51.5,
  16: 53,
  17: 54
};
var asics_men_us = {
  3: 4,
  3.5: 4.5,
  4: 5,
  4.5: 5.5,
  5: 6,
  5.5: 6.5,
  6: 7,
  6.5: 7.5,
  7: 8,
  7.5: 8.5,
  8: 9,
  8.5: 9.5,
  9: 10,
  9.5: 10.5,
  10: 11,
  10.5: 11.5,
  11: 12,
  11.5: 12.5,
  12: 13,
  13: 14,
  14: 15,
  15: 16,
  16: 17,
  17: 18
};

//women
var asics_women_eu = {
  3: 35.5,
  3.5: 36,
  4: 37,
  4.5: 37.5,
  5: 38,
  5.5: 39,
  6: 39.5,
  6.5: 40,
  7: 40.5,
  7.5: 41.5,
  8: 42,
  8.5: 42.5,
  9: 43.5,
  9.5: 44,
  10: 44.5,
  10.5: 45,
  11: 46,
  11.5: 46.5,
  12: 47
};
var asics_women_us = {
  3: 5,
  3.5: 5.5,
  4: 6,
  4.5: 6.5,
  5: 7,
  5.5: 7.5,
  6: 8,
  6.5: 8.5,
  7: 9,
  7.5: 9.5,
  8: 10,
  8.5: 10.5,
  9: 11,
  9.5: 11.5,
  10: 12,
  10.5: 12.5,
  11: 13,
  11.5: 13.5,
  12: 14
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!**********************************!*\
  !*** ./src/js/sizeconversion.js ***!
  \**********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sizes_conversions.js */ "./src/js/sizes_conversions.js");
























// import {
//     balenciaga_men_us,
//     balenciaga_men_eu,
// } from './sizes_conversions.js';

// import {
//     balenciaga_women_us,
//     balenciaga_women_eu,
// } from './sizes_conversions.js';

// import {
//     amiri_men_us,
//     amiri_men_eu,
// } from './sizes_conversions.js';

// import {
//     amiri_women_us,
//     amiri_women_eu,
// } from './sizes_conversions.js';

// import {
//     am_men_us,
//     am_men_eu,
// } from './sizes_conversions.js';

// import {
//     am_women_us,
//     am_women_eu,
// } from './sizes_conversions.js';

// import {
//     burberry_men_us,
//     burberry_men_eu,
// } from './sizes_conversions.js';

// import {
//     burberry_women_us,
//     burberry_women_eu,
// } from './sizes_conversions.js';

// import {
//     botegga_men_us,
//     botegga_men_eu,
// } from './sizes_conversions.js';
// import {
//     botegga_women_us,
//     botegga_women_eu,
// } from './sizes_conversions.js';

// import {
//     loubouton_men_us,
//     loubouton_men_eu,
// } from './sizes_conversions.js';
// import {
//     loubouton_women_us,
//     loubouton_women_eu,
// } from './sizes_conversions.js';




// import {
//     disquared_men_us,
//     disquared_men_eu,
// } from './sizes_conversions.js';
// import {
//     disquared2_men_us,
//     disquared2_men_eu,
// } from './sizes_conversions.js';
// import {
//     disquared2_women_us,
//     disquared2_women_eu,
// } from './sizes_conversions.js';












// import {
//     hermes_men_us,
//     hermes_men_eu,
// } from './sizes_conversions.js';
// import {
//     hermes_women_us,
//     hermes_women_eu,
// } from './sizes_conversions.js';
// import {
//     hermes_paris_men_us,
//     hermes_paris_men_eu,
// } from './sizes_conversions.js';
// import {
//     hermes_paris_women_us,
//     hermes_paris_women_eu,
// } from './sizes_conversions.js';

// import {
//     gucci_men_us,
//     gucci_men_eu,
// } from './sizes_conversions.js';
// import {
//     gucci_women_us,
//     gucci_women_eu,
// } from './sizes_conversions.js';








// import {
//     offwhite_men_us,
//     offwhite_men_eu,
// } from './sizes_conversions.js';
// import {
//     offwhite_women_us,
//     offwhite_women_eu,
// } from './sizes_conversions.js';

// import {
//     pa_men_us,
//     pa_men_eu,
// } from './sizes_conversions.js';
// import {
//     pa_women_us,
//     pa_women_eu,
// } from './sizes_conversions.js';

// import {
//     prada_men_us,
//     prada_men_eu,
// } from './sizes_conversions.js';
// import {
//     prada_women_us,
//     prada_women_eu,
// } from './sizes_conversions.js';




// import {
//     valentino_men_us,
//     valentino_men_eu,
// } from './sizes_conversions.js';
// import {
//     valentino_women_us,
//     valentino_women_eu,
// } from './sizes_conversions.js';

// import {
//     versace_men_us,
//     versace_men_eu,
// } from './sizes_conversions.js';
// import {
//     versace_women_us,
//     versace_women_eu,
// } from './sizes_conversions.js';

// import {
//     cl_men_us,
//     cl_men_eu,
// } from './sizes_conversions.js';
// import {
//     cl_women_us,
//     cl_women_eu,
// } from './sizes_conversions.js';

// import {
//     or_men_us,
//     or_men_eu,
// } from './sizes_conversions.js';
// import {
//     or_women_us,
//     or_women_eu,
// } from './sizes_conversions.js';






// import {
//     birkenstock_men_eu,
//     birkenstock_men_us,
// } from './sizes_conversions.js';
// import {
//     birkenstock_women_eu,
//     birkenstock_women_us,
// } from './sizes_conversions.js';

function toggleActiveClass(selectedButtonId) {
  var buttons = document.querySelectorAll('.size-btn');
  buttons.forEach(function (button) {
    if (button.id === selectedButtonId) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  });
}
function convertSize(size, fromSystem, toSystem, brand, gender, nickname, title) {
  var conversionChart;
  if (brand === 'nike' && gender === 'mens' && gender === 'mens' || brand === 'nike' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.nike_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.nike_men_us;
  } else if (brand === 'nike' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.nike_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.nike_women_us;
  } else if (brand === 'air-jordan' && gender === 'mens' || brand === 'air-jordan' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_men_us;
  } else if (brand === 'air-jordan' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_women_us;
  } else if (brand === 'nike' && gender === 'kids' && nickname.indexOf('ps') !== -1 || brand === 'nike' && gender === 'youth' && nickname.indexOf('ps') !== -1 || brand === 'nike' && gender === 'youth' && title.indexOf('ps') !== -1 || brand === 'nike' && gender === 'kids' && nickname.indexOf('ps') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_ps_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_ps_us;
  } else if (brand === 'nike' && gender === 'youth' && nickname.indexOf('gs') !== -1 || brand === 'nike' && gender === 'kids' && nickname.indexOf('gs') !== -1 || brand === 'nike' && gender === 'kids' && title.indexOf('gs') !== -1 || brand === 'nike' && gender === 'youth' && title.indexOf('gs') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_gs_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_gs_us;
  } else if (brand === 'nike' && gender === 'youth' && nickname.indexOf('td') !== -1 || brand === 'nike' && gender === 'kids' && nickname.indexOf('td') !== -1 || brand === 'nike' && gender === 'kids' && title.indexOf('td') !== -1 || brand === 'nike' && gender === 'youth' && title.indexOf('td') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_td_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_td_us;
  } else if (brand === 'air-jordan' && gender === 'air-jordan' && nickname.indexOf('ps') !== -1 || brand === 'air-jordan' && gender === 'youth' && nickname.indexOf('ps') !== -1 || brand === 'air-jordan' && gender === 'youth' && title.indexOf('ps') !== -1 || brand === 'air-jordan' && gender === 'kids' && nickname.indexOf('ps') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_ps_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_ps_us;
  } else if (brand === 'air-jordan' && gender === 'youth' && nickname.indexOf('gs') !== -1 || brand === 'air-jordan' && gender === 'kids' && nickname.indexOf('gs') !== -1 || brand === 'air-jordan' && gender === 'kids' && title.indexOf('gs') !== -1 || brand === 'air-jordan' && gender === 'youth' && title.indexOf('gs') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_gs_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_gs_us;
  } else if (brand === 'air-jordan' && gender === 'youth' && nickname.indexOf('td') !== -1 || brand === 'air-jordan' && gender === 'kids' && nickname.indexOf('td') !== -1 || brand === 'air-jordan' && gender === 'kids' && title.indexOf('td') !== -1 || brand === 'air-jordan' && gender === 'youth' && title.indexOf('td') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_td_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.aj_td_us;
  } else if (brand === 'dior-x-air-jordan' && gender === 'mens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.nike_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.nike_men_us;
  } else if (brand === 'adidas' && gender === 'mens' || brand === 'adidas' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.adidas_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.adidas_men_us;
  } else if (brand === 'adidas' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.adidas_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.adidas_women_us;
  } else if (brand === 'adidas' && gender === 'youth') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.adidas_kids_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.adidas_kids_us;
  } else if (brand === 'yeezy' && gender === 'mens' && nickname.indexOf('slide') === -1 && nickname.indexOf('rnnr') === -1 || brand === 'yeezy' && gender === 'unisex' && nickname.indexOf('slide') === -1 && nickname.indexOf('rnnr') === -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.yeezy_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.yeezy_men_us;
  } else if (brand === 'yeezy' && gender === 'mens' && nickname.indexOf('slide') !== -1 || brand === 'yeezy' && gender === 'unisex' && nickname.indexOf('slide') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.yeezy_slide_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.yeezy_slide_us;
  } else if (brand === 'yeezy' && gender === 'mens' && nickname.indexOf('rnnr') !== -1 || brand === 'yeezy' && gender === 'unisex' && nickname.indexOf('rnnr') !== -1) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.yeezy_rnnr_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.yeezy_rnnr_us;
  } else if (brand === 'louis-vuitton' && gender === 'mens' || brand === 'louis-vuitton' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_men_us;
  } else if (brand === 'louis-vuitton-x-nike' && gender === 'mens' || brand === 'louis-vuitton-x-nike' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_nike_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_nike_men_us;
  } else if (brand === 'louis-vuitton' && gender === 'mens' && title.indexOf('supreme-x') || brand === 'louis-vuitton' && gender === 'unisex' && title.indexOf('supreme-x')) {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_supreme_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_supreme_men_us;
  } else if (brand === 'louis-vuitton' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_women_us;
  } else if (brand === 'louis-vuitton-x-nike' && gender === 'mens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.lv_women_us;
  } else if (brand === 'dior' && gender === 'mens' || brand === 'dior' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dior_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dior_men_us;
  } else if (brand === 'dior' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dior_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dior_women_us;
  } else if (brand === 'balenciaga' && gender === 'mens' || brand === 'balenciaga' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? balenciaga_men_eu : balenciaga_men_us;
  } else if (brand === 'balenciaga' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? balenciaga_women_eu : balenciaga_women_us;
  } else if (brand === 'amiri' && gender === 'mens' || brand === 'amiri' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? amiri_men_eu : amiri_men_us;
  } else if (brand === 'amiri' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? amiri_women_eu : amiri_women_us;
  } else if (brand === 'alexander-mcqueen' && gender === 'mens' || brand === 'alexander-mcqueen' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? am_men_eu : am_men_us;
  } else if (brand === 'alexander-mcqueen' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? am_women_eu : am_women_us;
  } else if (brand === 'burberry' && gender === 'mens' || brand === 'burberry' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? burberry_men_eu : burberry_men_us;
  } else if (brand === 'burberry' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? burberry_women_eu : burberry_women_us;
  } else if (brand === 'botegga' && gender === 'mens' || brand === 'botegga' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? botegga_men_eu : botegga_men_us;
  } else if (brand === 'botegga' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? botegga_women_eu : botegga_women_us;
  } else if (brand === 'loubouton' && gender === 'mens' || brand === 'loubouton' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? loubouton_men_eu : loubouton_men_us;
  } else if (brand === 'loubouton' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? loubouton_women_eu : loubouton_women_us;
  } else if (brand === 'converse' && gender === 'mens' || brand === 'converse' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_men_us;
  } else if (brand === 'converse' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_women_us;
  } else if (brand === 'disquared' && gender === 'mens' || brand === 'disquared' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? disquared_men_eu : disquared_men_us;
  } else if (brand === 'disquared2' && gender === 'mens' || brand === 'disquared2' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? disquared2_men_eu : disquared2_men_us;
  } else if (brand === 'disquared2' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? disquared2_women_eu : disquared2_women_us;
  } else if (brand === 'dsquared' && gender === 'mens' || brand === 'dsquared' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? disquared_men_eu : disquared_men_us;
  } else if (brand === 'dsquared2' && gender === 'mens' || brand === 'dsquared2' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? disquared2_men_eu : disquared2_men_us;
  } else if (brand === 'dsquared2' && gender === 'womens') {} else if (brand === 'fendi' && gender === 'mens' || brand === 'fendi' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.fendi_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.fendi_men_us;
  } else if (brand === 'fendi' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.fendi_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.fendi_women_us;
  } else if (brand === 'celine' && gender === 'mens' || brand === 'celine' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.celine_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.celine_men_us;
  } else if (brand === 'celine' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.celine_women_eu : celinewo_men_us;
  } else if (brand === 'dg' && gender === 'mens' || brand === 'dg' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dg_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dg_men_us;
  } else if (brand === 'dg' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dg_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.dg_women_us;
  } else if (brand === 'vans' && gender === 'mens' || brand === 'vans' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.vans_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.vans_men_us;
  } else if (brand === 'vans' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.vans_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.vans_women_us;
  } else if (brand === 'giuseppe-zanotti' && gender === 'mens' || brand === 'giuseppe-zanotti' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.gz_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.gz_men_us;
  } else if (brand === 'giuseppe-zanotti' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.gz_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.gz_women_us;
  } else if (brand === 'hermes' && gender === 'mens' || brand === 'hermes' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? hermes_men_eu : hermes_men_us;
  } else if (brand === 'hermes' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? hermes_women_eu : hermes_women_us;
  } else if (brand === 'hermes-paris' && gender === 'mens' || brand === 'hermes-paris' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? hermes_paris_men_eu : hermes_paris_men_us;
  } else if (brand === 'hermes-paris' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? hermes_paris_women_eu : hermes_paris_women_us;
  } else if (brand === 'gucci' && gender === 'mens' || brand === 'gucci' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? gucci_men_eu : gucci_men_us;
  } else if (brand === 'gucci' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? gucci_women_eu : gucci_women_us;
  } else if (brand === 'givenchy' && gender === 'mens' || brand === 'givenchy' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.givenchy_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.givenchy_men_us;
  } else if (brand === 'givenchy' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.givenchy_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.givenchy_women_us;
  } else if (brand === 'manolo-blahnik' && gender === 'mens' || brand === 'manolo-blahnik' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.manolo_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.manolo_men_us;
  } else if (brand === 'manolo-blahnik' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.manolo_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.manolo_women_us;
  } else if (brand === 'moncler' && gender === 'mens' || brand === 'moncler' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.moncler_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.moncler_men_us;
  } else if (brand === 'moncler' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.moncler_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.moncler_women_us;
  } else if (brand === 'off-white' && gender === 'mens' || brand === 'off-white' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? offwhite_men_eu : offwhite_men_us;
  } else if (brand === 'off-white' && gender === 'womens') {} else if (brand === 'off-white-x-converse' && gender === 'mens' || brand === 'off-white-x-converse' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_men_us;
  } else if (brand === 'off-white-x-converse' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.converse_women_us;
  } else if (brand === 'palm-angels' && gender === 'mens' || brand === 'palm-angels' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? pa_men_eu : pa_men_us;
  } else if (brand === 'palm-angels' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? pa_women_eu : pa_women_us;
  } else if (brand === 'prada' && gender === 'mens' || brand === 'prada' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? prada_men_eu : prada_men_us;
  } else if (brand === 'prada' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? prada_women_eu : prada_women_us;
  } else if (brand === 'ugg' && gender === 'mens' || brand === 'ugg' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.ugg_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.ugg_men_us;
  } else if (brand === 'ugg' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.ugg_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.ugg_women_us;
  } else if (brand === 'valentino' && gender === 'mens' || brand === 'valentino' && gender === 'unisex' || brand === 'valentino-garavani' && gender === 'mens' || brand === 'valentino-garavani' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? valentino_men_eu : valentino_men_us;
  } else if (brand === 'valentino' && gender === 'womens' || brand === 'valentino-garavani' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? valentino_women_eu : valentino_women_us;
  } else if (brand === 'christian-louboutin' && gender === 'mens' || brand === 'christian-louboutin' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? cl_men_eu : cl_men_us;
  } else if (brand === 'christian-louboutin' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? cl_women_eu : cl_women_us;
  } else if (brand === 'on-running' && gender === 'mens' || brand === 'on-running' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? or_men_eu : or_men_us;
  } else if (brand === 'on-running' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? or_women_eu : or_women_us;
  } else if (brand === 'versace' && gender === 'mens' || brand === 'versace' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? versace_men_eu : versace_men_us;
  } else if (brand === 'versace' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? versace_women_eu : versace_women_us;
  } else if (brand === 'crocs' && gender === 'mens' || brand === 'crocs' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.crocs_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.crocs_men_us;
  } else if (brand === 'crocs' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.crocs_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.crocs_women_us;
  } else if (brand === 'new-balance' && gender === 'mens' || brand === 'new-balance' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.new_balance_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.new_balance_men_us;
  } else if (brand === 'new-balance' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.new_balance_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.new_balance_women_us;
  } else if (brand === 'birkenstock' && gender === 'mens' || brand === 'birkenstock' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? birkenstock_men_eu : birkenstock_men_us;
  } else if (brand === 'birkenstock' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? birkenstock_women_eu : birkenstock_women_us;
  } else if (brand === 'loro-piana' && gender === 'mens' || brand === 'loro-piana' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.loro_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.loro_men_us;
  } else if (brand === 'loro-piana' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.loro_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.loro_women_us;
  } else if (brand === 'asics' && gender === 'mens' || brand === 'asics' && gender === 'unisex') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.asics_men_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.asics_men_us;
  } else if (brand === 'asics' && gender === 'womens') {
    conversionChart = toSystem === 'EU' ? _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.asics_women_eu : _sizes_conversions_js__WEBPACK_IMPORTED_MODULE_0__.asics_women_us;
  }
  var convertedSize = conversionChart[size];
  if (convertedSize) {
    if (typeof convertedSize === 'string') {
      if (convertedSize.includes('-')) {
        return convertedSize;
      } else if (convertedSize.includes(' - ')) {
        var rangeParts = convertedSize.split(' - ');
        return rangeParts[0] + '-' + rangeParts[1];
      } else if (convertedSize.includes('/')) {
        var formattedSize = convertedSize.replace('/', '/');
        return formattedSize;
      } else if (/^\d+(\.\d+)?[A-Za-z]$/.test(convertedSize)) {
        return convertedSize;
      }
    } else {
      return convertedSize;
    }
  }
  return null;
}
function handleConversion(outputSystem) {
  var sizeConvertorDiv = document.querySelector('.size-convertor');
  var inputSizeElements = document.querySelectorAll('.variant-name');
  var euSizes = document.querySelectorAll('.variant-eu-name');
  inputSizeElements.forEach(function (element) {
    var originalSize = parseFloat(element.getAttribute('data-size')); //this converts strings into the first number, eg. "6|39" is returned as only 6 -- can't we just use the whole string?
    var inputSystem = 'UK';
    var brand = sizeConvertorDiv.getAttribute('data-brand');
    var gender = sizeConvertorDiv.getAttribute('data-gender');
    var nickname = sizeConvertorDiv.getAttribute('data-nickname');
    var title = sizeConvertorDiv.getAttribute('data-title');

    //console.log('data-size: ' + originalSize);
    //console.log('brand: ' + brand);
    //console.log('gender: ' + gender);

    //use a different var so we can convert back to UK
    var sizeForConversion = originalSize;
    var dataDefault = element.getAttribute('data-default');
    if (dataDefault !== 'UK') {
      sizeForConversion = element.getAttribute('data-size'); //get the full string from the size dataset instead
    }

    //console.log(sizeForConversion, inputSystem, outputSystem, brand, gender, nickname, title);

    var outputSize = originalSize;
    if (outputSystem !== 'UK') {
      outputSize = convertSize(sizeForConversion, inputSystem, outputSystem, brand, gender, nickname, title);
    }
    if (outputSize !== null) {
      element.textContent = outputSystem + ' ' + outputSize;
    }
  });
  toggleActiveClass('to' + outputSystem.toUpperCase());

  //hide EU size when viewing non-uk sizes
  if (outputSystem == 'UK') {
    euSizes.forEach(function (el) {
      el.classList.remove('hidden');
      el.parentElement.classList.add('text-[11px]');
    });
  } else {
    euSizes.forEach(function (el) {
      el.classList.add('hidden');
      el.parentElement.classList.remove('text-[11px]');
    });
  }
}
var ukButton = document.getElementById('toUK');
var euButton = document.getElementById('toEU');
var usButton = document.getElementById('toUS');
ukButton.addEventListener('click', function () {
  handleConversion('UK');
});
euButton.addEventListener('click', function () {
  handleConversion('EU');
});
usButton.addEventListener('click', function () {
  handleConversion('US');
});
})();

/******/ })()
;